import Vue from 'vue'
import { colors } from 'vuetify/lib';
import Vuetify from 'vuetify/lib/framework'
import ar from 'vuetify/lib/locale/ar';
Vue.use(Vuetify)

export default new Vuetify({
	rtl: true,
	lang: {
		locales: { ar },
		current: 'ar',
	},
	theme: {
		themes: {
			light: {
				primary: '#3a7bca',
				'add-color': '#3a7bca',
				'warning-color': colors.orange.darken2,
				'alert-color': colors.red.lighten1,
				'preview-color': colors.deepPurple.lighten1,
				error: '#ff3334',
				errorLight: '#eeb4b3',
				main: colors.grey.darken3,
				darkGreen: colors.green.darken1
			}
		},
	},
	icons: {
		values: {
			add: 'mdi-plus',
			remove: 'mdi-minus',
			view: 'mdi-eye',
			edit: 'mdi-pencil',
			close: 'mdi-close',
			delete: 'mdi-trash-can-outline',
			search: 'mdi-magnify',
			info: 'mdi-information',
			alert: 'mdi-alert-octagon-outline',
			back: 'mdi-arrow-left',
			check: 'mdi-checkbox-marked-circle-outline',
			falseCheck: 'mdi-close-circle-outline',
			emptyCircleCheck: 'mdi-checkbox-blank-circle-outline',
			calendar: 'mdi-calendar',
			excel: 'mdi-file-table',
			preview: 'mdi-eye',
			printer: 'mdi-printer',
			subgroup: 'mdi-chevron-down',
		},
	}
})
